
import { useMemo } from 'react';
import { BehavioralFactor, DevelopmentRecommendations } from '@/types/resultsTypes';

export const useDevelopmentRecommendations = (
  behavioralFactors: BehavioralFactor[],
  objectivityFactor: BehavioralFactor,
  scores: { dominance: number; extraversion: number; patience: number; formality: number }
): DevelopmentRecommendations => {
  return useMemo(() => {
    const allFactors = [...behavioralFactors, objectivityFactor];
    
    const strengths = allFactors.filter(f => f.percentile >= 75 || f.percentile <= 25);
    const growthAreas = allFactors.filter(f => f.percentile >= 30 && f.percentile <= 40);
    const balancedAreas = allFactors.filter(f => f.percentile > 40 && f.percentile < 75);

    const objectivityScore = objectivityFactor.score;

    return {
      strengths,
      growthAreas,
      balancedAreas,
      skillDevelopment: {
        leadership: scores.dominance > 0 ? 'advanced' : scores.dominance > -0.5 ? 'intermediate' : 'foundational',
        communication: scores.extraversion > 0 ? 'advanced' : scores.extraversion > -0.5 ? 'intermediate' : 'foundational',
        adaptability: scores.patience < 0 ? 'advanced' : scores.patience < 0.5 ? 'intermediate' : 'foundational',
        structure: scores.formality > 0 ? 'advanced' : scores.formality > -0.5 ? 'intermediate' : 'foundational',
        analysis: objectivityScore > 0 ? 'advanced' : objectivityScore > -0.5 ? 'intermediate' : 'foundational'
      }
    };
  }, [behavioralFactors, objectivityFactor, scores]);
};
